import React from 'react'
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'

import {generateAccounts,listAssessments} from '../services/generate-accounts'

export default () => 
    <PrimaryButton text='Create Generic Accounts'
        onClick={generateAccounts} />



// WEBPACK FOOTER //
// ./src/admin/components/GenericAccounts.js